module.exports = __webpack_public_path__ + "img/d20190727_7.47793d2f.jpg";